import { css } from 'styled-components';
import { colors, fonts } from '../../style-utilities/variables';
export default css`
  .counter-container {
    visibility: hidden;
  }
  .product-card h2 {
    text-align: center;
    color: ${colors.primary};
  }
`;
